'use strict'

import ApiClient from './ApiClient'

export default class AccessLogRepository {
  /**
   *  操作ログ一覧取得
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  postSearch (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      direction: data.direction
    }
    delete data.page
    delete data.direction

    return ApiClient().post(`/access-logs`, data, { params })
  }

  /**
   * データの保存期間設定更新
   * @param id 操作ログID
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/access-logs/${id}`)
  }

  /**
   * 名刺インポート、または名刺エクスポートの実ファイルをダウンロードします。
   * @param {object} options
   * @param id 操作ログID
   * @returns {*}
   */
  logDownload (options, id) {
    return ApiClient().get(`/access-logs/${id}/file`, options)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AccessLogRepository.js